enum PersonType {
  Hombre,
  Mujer,
}

export default PersonType;
